import * as React from 'react';
import { ApiStore } from '../../../stores/ApiStore';
import { bind, inject } from '../../../utils/decorators';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { FormGroup, Col, ControlLabel, FormControl, InputGroup, Button, Modal, ListGroup, ListGroupItem, Popover, OverlayTrigger } from 'react-bootstrap';
import FaIcon from '../../site/FaIcon';
import * as ApiTypes from '../../../models/ApiTypes';

interface IFormularElementDocId {
  editable?: boolean;
  kategorieguid: string;
  elementguid: string;
  value?: string;
  platzhalter: string;
  text: string;
  werte: string;
  anr?: string;
  onHandleValidation?: (validationstate: 'success' | 'warning' | 'error' | undefined) => void;
}

/** Komponente für Suche und Übernahme einer DocID aus einem Auftrag. Die Suchparameter werden in der Vorlage (im QIT) definiert. */
@observer
export default class FormularElementDocId extends React.Component<IFormularElementDocId, {}> {

  @inject(ApiStore) apiStore: ApiStore;

  @observable value: string = this.props.value ? this.props.value : '';
  @observable modalVisible: boolean = false;
  @observable dokumente: Array<ApiTypes.IDokumentSuchErgebnis> = [];

  popoverHint = (
    <Popover id="popover-trigger-hover-focus">
      Übernimmt, sofern vorhanden, das Aktenzeichen automatisch aus dem zur Eingabe passenden Dokument im Auftrag (z.B. Kalibrierschein).
    </Popover>
  );

  @bind @action setDokumente(dokumente: Array<ApiTypes.IDokumentSuchErgebnis>) {
    this.dokumente = dokumente;
  }

  async sucheDokumente(anr: string) {
    const dokumente = await this.apiStore.auftragDokumentenSuche(anr, this.props.werte);
    if (dokumente.ok) {
      this.setDokumente(dokumente.json);
    }
  }

  @bind @action setWert(wert: string) {
    this.value = wert;
    this.modalVisible = false;
    if (this.props.onHandleValidation) {
      this.props.onHandleValidation(this.getValidationState());
    }
  }

  @bind @action setModal(value: boolean) {
    this.modalVisible = value;
  }

  @bind @action showModal() {
    // Dokumente laden
    if (this.props.anr) {
      this.sucheDokumente(this.props.anr).then(resp => {
          // Wenn es nur ein Dokument gibt, wir dessen DocID direkt übernommen
          if (this.dokumente.length === 1) {
            this.setWert(this.dokumente[0].docid);
            return;
          }
          if (this.dokumente.length === 0) {
            // @todo: Meldung anzeigen?
            return;
          }
          // Wenn es mehrere Dokumente gibt, dann muss der Nutzer in einem modalen Dialog das korrekte auswählen
          this.setModal(true);
        }
      );
    }
  }

  @bind @action hideModal() {
    this.setModal(false);
  }

  @bind @action handleValueChanged(event: React.FormEvent<FormControl>) {
    this.setWert((event.target as HTMLInputElement).value);
  }

  private getValidationState() {
    if (!this.props.editable) {
      return undefined;
    }
    return (this.value.length === 10) ? 'success' : 'error';
  }

  render() {
    const validationState = this.getValidationState();
    let btnClass = 'btn-group';
    if (validationState === 'error') {
      btnClass += ' button-error';
    }
    if (validationState === 'success') {
      btnClass += ' button-success';
    }
    return (
      <FormGroup controlId={this.props.text} validationState={validationState} className="formular-element-row">
        <Col componentClass={ControlLabel} sm={9} className="formular-element-caption">{this.props.text}</Col>
        <Col componentClass={ControlLabel} sm={3} className="formular-element">
          <InputGroup>
            <FormControl readOnly={!this.props.editable} onChange={this.handleValueChanged} type="text" name={`${this.props.kategorieguid}[${this.props.elementguid}]`} value={this.value} placeholder={this.props.platzhalter}/>
              {/* Button zur Übernahme der DocID wird nur angezeigt wenn Datensatz editiert werden darf */}
              {this.props.editable &&
              <OverlayTrigger trigger={['hover', 'focus', 'click']} placement="top" overlay={this.popoverHint}>
                <InputGroup.Button style={{width: '28px'}}>
                  <Button bsStyle="default" className={btnClass} disabled={false} onClick={this.showModal}> <FaIcon icon="files-o" />
                  </Button>
                </InputGroup.Button>
              </OverlayTrigger>}
          </InputGroup>
        </Col>

        <Modal show={this.modalVisible} onHide={this.hideModal} className="modal-vertical-centered" backdrop={'static'}>
          <Modal.Header closeButton={true}>
            <Modal.Title>Aktenzeichen für {this.props.text} auswählen</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ListGroup fill={true}>
              {this.dokumente.map((dokument, index) => (
                <ListGroupItem key={index} onClick={() => this.setWert(dokument.docid)}>
                  {dokument.datum} - {dokument.titel} ({dokument.docid})
                </ListGroupItem>
              ))}
            </ListGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.hideModal} bsStyle="default">Abbrechen</Button>
          </Modal.Footer>
        </Modal>

      </FormGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/formularelemente/FormularElementDocId.tsx